import React, { useState } from 'react'
import { 
  Col, 
  Row, 
  Image, 
  Input, 
  Space, 
  Button, 
  // Layout 
} from 'antd';
import { login } from '../../Utils/api/Auth';
import { 
  UserOutlined, 
  LockOutlined, 
  EyeInvisibleOutlined, 
  EyeTwoTone 
} from '@ant-design/icons';
// import { useNavigate } from "react-router-dom"
import HeaderLogo from "../../Assets/alta_logo.png"
// import HeaderImage from "../../Assets/golf-img.jpg"
import toast from 'react-hot-toast';
import { 
  // getToken, 
  refreshPage,
} from '../../Utils/Common';
import { HashLoader } from 'react-spinners';
const Login = () => {
  // const navigate = useNavigate()
  const [loginCredential, setLoginCredential] = useState({
    email: '',
    password: '',
  })
  const [isLoading, setIsLoading] = useState(false)

  const handleChange = (e) => {
    const {name, value} = e.target
    setLoginCredential({
      ...loginCredential,
      [name]: value
    })
  }
  
  const onSubmit = async () => {
    setIsLoading(true);
    const response = await login(loginCredential);
    if (response.data){
      localStorage.setItem('token', JSON.stringify(response.data.token));
      localStorage.setItem('user_id', JSON.stringify(response.data.id));
      localStorage.setItem('full_name', JSON.stringify(response.data.name));
      localStorage.setItem('role_id', JSON.stringify(response.data.role_id));
      localStorage.setItem('role_name', JSON.stringify(response.data.role));
      // localStorage.setItem('fullname', JSON.stringify(response.data.full_name));
      localStorage.setItem('token_expiry', JSON.stringify(response.data.token_expiry));

      toast.success(response.data.message)
      setTimeout(()=>{
        refreshPage();
        // navigate('/property')
      },[])
    } else {
      toast.error(response.error.message)
    }
    setIsLoading(false);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      onSubmit();
    }
  };
  return (
    <Row className='bg-login page'>
      <Col 
        xs={24} sm={24} md={24} lg={24} xl={24}
        align='right'
        className='responsive-center'
      >
        <Space
          className='login-right-col'
          direction='vertical'
        >
          <Row className='myt-logo center'>
            <Col>
              <Image
                width='auto'
                height='25vh' 
                src={HeaderLogo}
                alt="login-image"
                preview={false}
                className='logo'
              />
            </Col>
          </Row>
          <Row className='center'>
            <Col className='login-title'>
              SCORING     
            </Col>
          </Row>
          <Row className='center'>
            <Col>
              <Row className='space-bottom'>
                <Col>
                  <Input 
                    className='input-width login-fields padding-fields'
                    name='email'
                    size="large" 
                    placeholder="Email" 
                    onChange={(e) => handleChange(e)}
                    onKeyDown={handleKeyPress}
                    prefix={<UserOutlined />} 
                  />
                </Col>
              </Row>
              <Row className='space-bottom'>
                <Col>
                  <Space direction="vertical">
                    <Input.Password
                      className='input-width login-fields padding-fields'
                      size='large'
                      name='password'
                      onChange={(e) => handleChange(e)}
                      onKeyDown={handleKeyPress}
                      placeholder="Password"
                      iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                      prefix={<LockOutlined />}
                    />
                  </Space>
                </Col>
              </Row>
              <Row className='space-bottom center'>
                <Col>
                    {isLoading ? (
                      <HashLoader color="#005E30" size={40} />
                    ) : (
                      <Button 
                        type="primary"
                        size='large'
                        className='login-fields login-btn'
                        onClick={onSubmit}
                        disabled={isLoading}
                      >
                        Login
                      </Button>
                    )}
                </Col>
              </Row>
              <Row className='center login-footer'>
                <div>
                  Powered by MYT Softdev Solutions Inc.
                </div>
              </Row>
            </Col>
          </Row>
        </Space>
      </Col>
    </Row>
  )
}

export default Login
